import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import Nhiucosan from './image/booking/nhiucosan.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: "06:00 PM", description: "Khởi hành từ Hà Nội đi thị trấn Mường Hum của Lào Cai" },
      { time: "00:30 AM", description: "Có mặt tại homestay tại Mường Hum để nghỉ ngơi tạm thời" },
      { 
        description: "Một giấc ngủ ngắn nhưng chất lượng trên xe và sự chuẩn bị kỹ lưỡng là cách chúng ta trân trọng cơ thể mình. Đừng quên kiểm tra lại những vật dụng cá nhân cuối cùng trước khi bắt đầu hành trình chinh phục." 
      }
    ],
  },
  {
    day: "Thứ 7 - Thác Ong Chúa & Đỉnh Núi",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng đặc sản địa phương và thưởng thức không khí vùng cao" },
      { 
        description: "Bữa sáng đầy đủ tinh bột và đạm là bí quyết để đôi chân bền bỉ. Tại đây, chúng mình sẽ gửi lại những đồ dùng không cần thiết để hành trình leo núi nhẹ nhàng, thanh thoát nhất có thể." 
      },
      { time: "07:30 AM", description: "Di chuyển bằng xe máy (xe ôm bản địa) tới điểm bắt đầu leo" },
      { 
        description: "Trải nghiệm ngồi sau tay lái của những tay đua bản địa xuyên qua những cung đường uốn lượn, ngắm nhìn thung lũng Sang Ma Sáo ẩn hiện trong sương sớm. Đây là lúc tâm hồn bạn bắt đầu được tự do." 
      },
      { time: "08:30 AM", description: "Bắt đầu leo núi theo hướng bãi thả ngựa" },
      { 
        description: "Cung đường này mang vẻ đẹp khác biệt với những đồng cỏ bao la và tầm nhìn thoáng đạt. Lưu ý siết chặt dây giày và bước đi chậm rãi để bảo vệ đôi chân của mình nhé." 
      },
      { time: "12:30 PM", description: "Nghỉ dừng chân và dùng bữa trưa" },
      { 
        description: "Giữa tiếng suối róc rách và gió rừng, một bữa trưa giản đơn cũng trở nên tuyệt diệu. Hãy chợp mắt 15 phút để nạp lại năng lượng cho đoạn đường dốc phía trước." 
      },
      { time: "01:30 PM", description: "Tới lán nghỉ" },
      { 
        description: "Lán nghỉ Nhìu Cồ San kín gió, nằm giữa rừng trúc dập dìu là điểm dừng chân để bạn nghỉ ngơi, chuẩn bị chinh phục đỉnh Nhìu Cồ San" 
      },
      { time: "04:30 PM", description: "Chạm đỉnh Nhìu Cồ San (2.965m)" },
      { 
        description: "Khoảnh khắc chạm tay vào chóp inox là lúc mọi mệt mỏi tan biến. Hãy tận hưởng ánh hoàng hôn rực rỡ từ trên cao, nơi bạn thấy mình đang đứng giữa lưng chừng trời." 
      },
      { time: "06:00 PM", description: "Di chuyển về lán nghỉ" },
      { 
        description: "Lán nghỉ nằm tách biệt, không sóng điện thoại, không ồn ào. Chỉ có chúng ta bên ánh lửa hồng, những câu chuyện hàn huyên và hơi ấm của sự đồng hành." 
      }
    ],
  },
  {
    day: "Chủ Nhật - Biển Mây & Trở Về",
    activities: [
      { time: "06:00 AM", description: "Thức dậy đón bình minh và thưởng thức cafe mây tại lán" },
      { 
        description: "Đón những tia nắng đầu tiên xuyên qua kẽ lá, nhâm nhi tách cafe nóng hổi giữa biển mây bồng bềnh. Đây chính là phần thưởng ngọt ngào nhất cho nỗ lực của bạn." 
      },
      { time: "08:00 AM", description: "Bắt đầu trekking qua tuyến đường Thác Ong Chúa" },
      { 
        description: "Chúng ta sẽ đi qua thác Ong Chúa hùng vĩ - kiệt tác của đại ngàn. Các bạn nữ hãy sẵn sàng cho những khung hình lung linh nhất giữa làn nước trắng xóa và rừng già nguyên sinh nhé." 
      },
      { time: "12:30 PM", description: "Về tới chân núi, ăn trưa nhẹ nhàng tại bản" },
      { time: "02:00 PM", description: "Trở về homestay, trải nghiệm tắm lá thuốc người Dao đỏ" },
      { 
        description: "Sau hai ngày băng rừng, được ngâm mình trong làn nước thơm mùi thảo mộc sẽ giúp các khối cơ được thả lỏng hoàn toàn, mang lại cảm giác sảng khoái tức thì." 
      },
      { time: "04:00 PM", description: "Lên xe khởi hành về lại Hà Nội" },
      { 
        description: "Tạm biệt Nhìu Cồ San, chúng ta mang theo không chỉ là những bức ảnh đẹp, mà là sự tự tin và những kỷ niệm vô giá về một hành trình vượt qua giới hạn bản thân." 
      },
      { time: "10:00 PM", description: "Về tới Hà Nội. Kết thúc chuyến đi an toàn và trọn vẹn." }
    ],
  },
];

const NhiuCoSanSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>Nhìu Cồ San – Khám phá thác Ong Chúa độc nhất vô nhị Tây Bắc</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Nhìu Cồ San – ngọn núi cao 2.965 mét tại Y Tý, không chỉ là một đỉnh cao trong bộ sưu tập chinh phục, 
          mà còn là “Cung đường của những ngọn Thác và Khu Rừng Rêu Kỳ Ảo”. Hành trình này mời gọi bạn bước vào 
          một thế giới hoang sơ, ẩm ướt và đầy mê hoặc, khác biệt hoàn toàn so với các đỉnh núi khác.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Hoa đỗ quyên đỏ rừng Nhìu Cồ San
        </p>
        <img src={Nhiucosan} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default NhiuCoSanSchedule;